import React, { useState } from "react";
import { IoEyeOff, IoEye, IoSearchSharp } from "react-icons/io5";
import * as S from "./styles";

const BorderedInputText = ({
  type,
  name,
  label,
  width,
  height,
  radius,
  border,
  icon,
  error,
  visState,
  ...rest
}) => {
  if (visState === "false") {
    visState = false;
  } else {
    visState = true;
  }
  const [passwordShown, setPasswordShown] = useState(visState);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  function isPassword() {
    if (icon === "true") {
      return passwordShown ? (
        <IoEyeOff color="#00a2e0" size="35px" />
      ) : (
        <IoEye color="#00a2e0" size="35px" />
      );
    } else {
      return;
    }
  }

  return (
    <S.Container width={width}>
      <S.Wrapper>
        <S.Label className="labelInputBordered">{label}</S.Label>
        <S.Input
          name={name}
          type={passwordShown ? "text" : "password"}
          {...rest}
        />
        <span className="eye-icon" onClick={togglePasswordVisiblity}>
          {isPassword()}
        </span>
      </S.Wrapper>
      <S.LabelUnder error={error}>
        {error}
      </S.LabelUnder>
    </S.Container>
  );
};

export default BorderedInputText;
